/**
 * @generated SignedSource<<39573effa1e570b3c0fd3e77351ee0aa>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type JiraProjectType = "BUSINESS" | "CUSTOMER_SERVICE" | "PRODUCT_DISCOVERY" | "SERVICE_DESK" | "SOFTWARE" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type TabsContent_project$data = {
  readonly projectId: string | null | undefined;
  readonly projectType: JiraProjectType | null | undefined;
  readonly " $fragmentType": "TabsContent_project";
};
export type TabsContent_project$key = {
  readonly " $data"?: TabsContent_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"TabsContent_project">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "TabsContent_project",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "projectType"
    },
    {
      "kind": "ScalarField",
      "name": "projectId"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "abf520acd7725543508b669e38084bfa";

export default node;
